import type { LucideIcon } from "lucide-react";
import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

/** Every list has one: why it is empty and what to do next. */
export function EmptyState({
  icon: Icon = Inbox,
  title,
  children,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: string;
  children?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col items-center gap-2 px-6 py-12 text-center", className)}>
      <Icon aria-hidden className="text-muted-foreground size-8" strokeWidth={1.5} />
      <h2 className="text-base">{title}</h2>
      {children && <p className="text-muted-foreground max-w-md text-sm">{children}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
